// extracted by mini-css-extract-plugin
export var box = "_27-2";
export var checkboxControl = "_27-0";
export var checkboxRow = "_27-a";
export var checked = "_27-3";
export var descriptionSpacer = "_27-c";
export var disabled = "_27-4";
export var icon = "_27-8";
export var input = "_27-1";
export var labelSpacer = "_27-b";
export var large = "_27-7";
export var medium = "_27-6";
export var small = "_27-5";
export var text = "_27-9";